import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { getCurrentMillis } from '../utils/dateUtils';

export interface SupportInquiry {
  id?: string;
  type: string;
  message: string;
  status: number; // 0: pending, 1: in_progress, 2: resolved, 3: closed
  userId: string;
  userEmail: string;
  userName: string;
  createdAt: Timestamp | string;
  updatedAt: Timestamp | string;
  adminResponse?: string;
  adminId?: string;
}

export const SUPPORT_INQUIRIES_REF = 'ContactUs';

export const createSupportInquiry = async (inquiry: Omit<SupportInquiry, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> => {
  try {
    console.log('🔍 Debug - SupportService: Creating support inquiry with data:', inquiry);
    
    const inquiryData = {
      ...inquiry,
      status: 0, // Always start as pending
      createdAt: getCurrentMillis(),
      updatedAt: getCurrentMillis()
    };

    console.log('🔍 Debug - SupportService: Prepared inquiry data for Firestore:', inquiryData);

    const docRef = await addDoc(collection(db, SUPPORT_INQUIRIES_REF), inquiryData);
    console.log('✅ Support inquiry created with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('❌ Error creating support inquiry:', error);
    console.error('❌ Error details:', {
      message: error instanceof Error ? error.message : 'Unknown error',
      code: (error as any)?.code || 'No code',
      name: (error as any)?.name || 'No name',
      stack: error instanceof Error ? error.stack : 'No stack',
      inquiryData: inquiry
    });
    
    // Check for specific Firestore errors
    if (error instanceof Error) {
      if (error.message.includes('permission')) {
        console.error('❌ Firestore permission error - check security rules');
      } else if (error.message.includes('network')) {
        console.error('❌ Network error - check internet connection');
      } else if (error.message.includes('quota')) {
        console.error('❌ Firestore quota exceeded');
      }
    }
    
    throw error;
  }
};

export const getSupportInquiryStatusText = (status: number, language: 'en' | 'ar'): string => {
  const statusMap = {
    0: language === 'ar' ? 'معلق' : 'Pending',
    1: language === 'ar' ? 'قيد المراجعة' : 'In Progress',
    2: language === 'ar' ? 'تم الحل' : 'Resolved',
    3: language === 'ar' ? 'مغلق' : 'Closed'
  };
  
  return statusMap[status as keyof typeof statusMap] || statusMap[0];
};
